module.exports = __webpack_public_path__ + "public/media/pinpaifupin.8bb0ce1c.mp4";